module.exports = __webpack_public_path__ + "37506adb0c4e9dd9e4782ce91b8cdea4.svg";